import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useTheme } from '@mui/material';
import { PageHeader } from '../../components/PageHeader';
import { CreativeBrandStudyResult } from './CreativeBrandStudyResult';
import { CreativeBrandStudyForm } from './CreativeBrandStudyForm';
import { SurveyResult } from './SurveyResult';
import { useStudyContext } from '../../context';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
export const AiCreativePreTestingPage = () => {
    const theme = useTheme();
    const { studyResultData, studyResultDataLoading, resetStudyData, loadStudyById } = useStudyContext();
    const { studyId } = useParams();
    useEffect(() => {
        resetStudyData();
    }, []);
    useEffect(() => {
        if (studyId && studyId !== 'new') {
            loadStudyById(parseInt(studyId));
        }
    }, [studyId]);
    return (_jsxs(Box, { padding: "20px", paddingLeft: "30px", boxSizing: "border-box", children: [_jsx(PageHeader, { title: "AI Creative Pre Testing", breadcrumbs: [
                    { label: 'Creative Management', href: '/' },
                    { label: 'AI Creative Pre Testing' },
                ] }), _jsxs(Box, { border: 1, padding: "16px", marginTop: "25px", borderRadius: "8px", borderColor: theme.palette.divider, bgcolor: theme.palette.background.default, children: [_jsx(CreativeBrandStudyForm, {}), !studyResultDataLoading && (studyResultData === null || studyResultData === void 0 ? void 0 : studyResultData.result) && (_jsxs(_Fragment, { children: [_jsx(CreativeBrandStudyResult, {}), _jsx(SurveyResult, {})] }))] })] }));
};
